module.exports = __webpack_public_path__ + "img/Yunnan-power.1cce9a4c.png";